import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { FetchCurrency } from './reducer_currency';
import { CurrentBooking, BookingGroup } from './reducer_booking';
import { FetchNationality, FetchNationalityState } from './reducer_nationality';
import { FetchCapacity, FetchLiveCapacity } from './reducer_capacity';
import { FetchProduct, FetchProducts } from './reducer_product';
import { FetchDiscount } from './reducer_discount';
import { Contentful } from './reducer_contentful';
import { FetchErrors } from './reducer_errors';
import { ToggleModal } from './reducer_modal';
import { UpdatePassengers } from './reducer_passenger';
import { FetchItineraries } from './reducer_itineraries';
import { FetchUpgrades } from './reducer_upgrades';

const rootReducer = combineReducers({
  upgrades:FetchUpgrades,
  itineraries:FetchItineraries,
  form:formReducer,
  currency:FetchCurrency,
  nationality:FetchNationality,
  nationalityState:FetchNationalityState,
  bookingGroup:BookingGroup,
  currentBooking:CurrentBooking,
  capacity:FetchCapacity,
  liveCapacity:FetchLiveCapacity,
  product:FetchProduct, //SINGLE PRODUCT
  products:FetchProducts, //ALL PRODUCTS
  discount:FetchDiscount,
  contentful:Contentful,
  errorMessages:FetchErrors,
  toggleModal:ToggleModal,
  updatePassengers:UpdatePassengers
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js